import * as Sentry from "@sentry/react"
import type { AfterResponseHook, BeforeErrorHook } from "ky"
import { captureError } from "./sentry"
import { trackEvent, Events } from "./analytics"

export const telemetryAfterResponse: AfterResponseHook = (
  request,
  _options,
  response,
) => {
  Sentry.addBreadcrumb({
    category: "http",
    message: `${request.method} ${request.url}`,
    data: {
      status_code: response.status,
      url: request.url,
      method: request.method,
    },
    level: response.ok ? "info" : "warning",
  })
}

export const telemetryBeforeError: BeforeErrorHook = (error) => {
  const { response, request } = error

  if (response.status !== 401) {
    captureError(error, {
      url: request.url,
      method: request.method,
      status: response.status,
    })

    trackEvent(Events.API_ERROR, {
      url: request.url,
      method: request.method,
      status: String(response.status),
    })
  }

  return error
}
